export enum Roles {
	USER = 'User',
	ADMIN = 'Admin',
	CLIENT_MANAGER = 'ClientManager'
}
